var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechMarksBottomRightGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2309 4.719C14.1787 3.57825 12.5864 3 10.4992 3H9.74919V5.11425L10.3522 5.235C11.3797 5.4405 12.0944 5.84475 12.4769 6.438C12.6765 6.7576 12.7897 7.12353 12.8054 7.5H10.4992C10.3003 7.5 10.1095 7.57902 9.96886 7.71967C9.82821 7.86032 9.74919 8.05109 9.74919 8.25V13.5C9.74919 14.3273 10.4219 15 11.2492 15H15.7492C15.9481 15 16.1389 14.921 16.2795 14.7803C16.4202 14.6397 16.4992 14.4489 16.4992 14.25V10.5L16.4969 8.31075C16.5037 8.2275 16.6462 6.255 15.2309 4.719ZM2.99919 15H7.49919C7.6981 15 7.88887 14.921 8.02952 14.7803C8.17017 14.6397 8.24919 14.4489 8.24919 14.25V10.5L8.24694 8.31075C8.25369 8.2275 8.39619 6.255 6.98094 4.719C5.92869 3.57825 4.33644 3 2.24919 3H1.49919V5.11425L2.10219 5.235C3.12969 5.4405 3.84444 5.84475 4.22694 6.438C4.42652 6.7576 4.53971 7.12353 4.55544 7.5H2.24919C2.05028 7.5 1.85951 7.57902 1.71886 7.71967C1.57821 7.86032 1.49919 8.05109 1.49919 8.25V13.5C1.49919 14.3273 2.17194 15 2.99919 15Z",
    fill: "#D4BC87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechMarksBottomRightGold);
export default __webpack_public_path__ + "static/media/speech-marks-bottom-right-gold.d93acca6799126afc2cca1f17aa6ff3e.svg";
export { ForwardRef as ReactComponent };